/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-unused-prop-types */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { CampaignDetailsTabTypes, Networks, EntityTypes, AttributionViews } from 'AdsUI/lib/Constants';
import AdAccountRecord from 'AdsUI/records/ad-accounts/AdAccountRecord';
import ReportingDataRecord from 'AdsUI/records/reporting/ReportingDataRecord';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import UIHeader from 'UIComponents/layout/UIHeader';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import CampaignDetailsHeader from './CampaignDetailsHeader';
import CampaignDetailsTabsContainer from 'AdsUI/containers/campaign-details/CampaignDetailsTabsContainer';
import CampaignDetailsTableContainer from 'AdsUI/containers/campaign-details/CampaignDetailsTableContainer';
import CampaignsPerformanceWells from 'AdsUI/components/CampaignsPerformanceWells';
import GlobalTimeRangeFilterContainer from 'AdsUI/components/GlobalTimeRangeFilterContainer';
import GlobalAttributionViewFilterContainer from 'AdsUI/components/GlobalAttributionViewFilterContainer';
import GlobalCampaignStatusFilterContainer from '../GlobalCampaignStatusFilterContainer';
import TimeZoneMessage from 'AdsUI/components/TimeZoneMessage';
import { NavMarker } from 'react-rhumb';
import { LayoutWithCollaborationSidebar, CommentObjectType, FEATURES, SUPPORTED_HUBS } from 'collaboration-sidebar';

class CampaignDetailsPage extends PureComponent {
  renderHeader() {
    const {
      campaignDetails: {
        entity
      },
      network,
      adAccount,
      canEditCampaignName,
      onChangeCampaignName,
      showCampaignManagement,
      onEditCampaign,
      onOpenCampaignPanel,
      campaignStatus
    } = this.props;
    return !entity ? /*#__PURE__*/_jsx(UIHeader, {}) : /*#__PURE__*/_jsx(CampaignDetailsHeader, {
      entity: entity,
      entityType: EntityTypes.CAMPAIGN,
      network: network,
      adAccount: adAccount,
      canEditCampaignName: canEditCampaignName,
      onChangeCampaignName: onChangeCampaignName,
      showCampaignManagement: showCampaignManagement,
      onEditCampaign: onEditCampaign,
      onOpenCampaignPanel: onOpenCampaignPanel,
      campaignStatus: campaignStatus
    });
  }

  renderCampaignPerformanceWells() {
    const {
      campaignDetails: {
        entity,
        report
      },
      network,
      loading
    } = this.props;
    return /*#__PURE__*/_jsx(CampaignsPerformanceWells, {
      entity: entity,
      data: report,
      isLoaded: !loading,
      network: network,
      className: "details-page-wells"
    });
  }

  render() {
    const {
      campaignDetails: {
        entity
      },
      campaignId,
      loading,
      network
    } = this.props;
    return /*#__PURE__*/_jsx(LayoutWithCollaborationSidebar, {
      objectId: `${network}-${campaignId}`,
      objectType: CommentObjectType.AD_CAMPAIGN,
      appName: "ad-campaign-details",
      appHub: SUPPORTED_HUBS.MARKETING_HUB,
      scrollablePage: true,
      enabledFeatures: [FEATURES.COMMENTS, FEATURES.TASKS, FEATURES.CALENDAR, FEATURES.CAMPAIGNS],
      children: /*#__PURE__*/_jsxs(UIDashboardPage, {
        headerComponent: this.renderHeader(),
        tabs: /*#__PURE__*/_jsx(CampaignDetailsTabsContainer, {
          network: network,
          campaignEntity: entity,
          activeTab: CampaignDetailsTabTypes.MANAGE
        }),
        className: "campaign-details-page",
        pageLayout: "full-width",
        children: [/*#__PURE__*/_jsxs(UIToolBar, {
          use: "filter-bar",
          className: "m-top-0",
          children: [/*#__PURE__*/_jsxs(UIToolBarGroup, {
            children: [/*#__PURE__*/_jsx(GlobalTimeRangeFilterContainer, {}), /*#__PURE__*/_jsx(GlobalAttributionViewFilterContainer, {}), /*#__PURE__*/_jsx(GlobalCampaignStatusFilterContainer, {})]
          }), /*#__PURE__*/_jsx(UIToolBarGroup, {})]
        }), this.renderCampaignPerformanceWells(), /*#__PURE__*/_jsx(CampaignDetailsTableContainer, {}), /*#__PURE__*/_jsx(TimeZoneMessage, {}), !loading && /*#__PURE__*/_jsx(NavMarker, {
          name: "CAMPAIGN_DETAILS_LOADED"
        })]
      })
    });
  }

}

CampaignDetailsPage.propTypes = {
  loading: PropTypes.bool.isRequired,
  campaignId: PropTypes.string.isRequired,
  campaignDetails: PropTypes.instanceOf(ReportingDataRecord).isRequired,
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  adAccount: PropTypes.instanceOf(AdAccountRecord).isRequired,
  attributionView: PropTypes.oneOf(Object.keys(AttributionViews)).isRequired,
  timeRange: PropTypes.object.isRequired,
  campaignStatus: PropTypes.string
};
export default CampaignDetailsPage;